export default __webpack_public_path__ + "static/media/study_traektory.d9ebc9a8.svg";